<template>
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
      fill="#E0E0E0"
    />
    <path
      d="M49.9999 93.2573C73.8904 93.2573 93.2574 73.8902 93.2574 49.9997C93.2574 26.1092 73.8904 6.74219 49.9999 6.74219C26.1094 6.74219 6.74234 26.1092 6.74234 49.9997C6.74234 73.8902 26.1094 93.2573 49.9999 93.2573Z"
      fill="#E0E0E0"
    />
    <g filter="url(#filter0_ddd)">
      <path
        d="M73.62 23.2109H51.5258H48.9287H27.0234C24.992 23.2109 23.3454 24.4006 23.3454 25.868V27.6393C23.3454 27.6393 23.3454 32.0954 23.3454 33.7285C23.3452 39.0191 23.3454 42.7694 23.3454 50.3357C23.3454 57.902 23.3454 76.3542 23.3454 76.3542V78.1255C23.3454 79.5928 24.992 80.7825 27.0234 80.7825H73.62C75.6514 80.7825 77.2974 79.5928 77.2974 78.1255V76.3542V27.6397V25.8684C77.298 24.4006 75.6514 23.2109 73.62 23.2109Z"
        fill="#81581C"
      />
    </g>
    <path
      d="M65.0018 77.223H36.1048C34.6371 77.223 33.4474 76.0333 33.4474 74.566V65.0438C33.4474 63.576 34.6371 62.3867 36.1048 62.3867H65.0022C66.4696 62.3867 67.6593 63.5764 67.6593 65.0438V74.5655C67.6593 76.0329 66.4696 77.223 65.0018 77.223Z"
      fill="#382B73"
    />
    <path
      d="M73.6195 77.8523H27.0227C24.9913 77.8523 23.3447 76.6626 23.3447 75.1953V24.7078C23.3447 23.2401 24.9913 22.0508 27.0227 22.0508H73.6195C75.6509 22.0508 77.2975 23.2405 77.2975 24.7078V75.1948C77.2975 76.6626 75.6509 77.8523 73.6195 77.8523Z"
      fill="#A77223"
    />
    <path
      d="M73.6195 76.0823H27.0227C24.9913 76.0823 23.3447 74.8926 23.3447 73.4253V22.9383C23.3447 21.4705 24.9913 20.2812 27.0227 20.2812H73.6195C75.6509 20.2812 77.2975 21.4709 77.2975 22.9383V73.4253C77.2975 74.8926 75.6509 76.0823 73.6195 76.0823Z"
      fill="#FFB74D"
    />
    <path
      d="M50.7569 20.2812H49.7496V76.0828H50.7569V20.2812Z"
      fill="#A77223"
    />
    <path
      d="M51.6805 24.1641H48.827C48.3513 24.1641 47.9655 24.5498 47.9655 25.0255V25.4563V30.5173V30.948C47.9655 31.4237 48.3513 31.8095 48.827 31.8095H51.6805C52.1562 31.8095 52.542 31.4237 52.542 30.948V30.5173V25.4563V25.0255C52.542 24.5498 52.1562 24.1641 51.6805 24.1641ZM48.9749 28.202C48.9749 27.9642 49.1678 27.7713 49.4056 27.7713H51.1016C51.3395 27.7713 51.5324 27.9642 51.5324 28.202V29.898C51.5324 30.1359 51.3395 30.3287 51.1016 30.3287H49.4056C49.1678 30.3287 48.9749 30.1359 48.9749 29.898V28.202Z"
      fill="#A77223"
    />
    <path
      d="M51.6806 24.1602H48.8271C48.3514 24.1602 47.9656 24.5459 47.9656 25.0216V30.5134C47.9656 30.9891 48.3514 31.3749 48.8271 31.3749H51.6806C52.1563 31.3749 52.5421 30.9891 52.5421 30.5134V25.0216C52.5421 24.5459 52.1563 24.1602 51.6806 24.1602ZM51.5325 29.4634C51.5325 29.7012 51.3396 29.8941 51.1017 29.8941H49.4057C49.1679 29.8941 48.975 29.7012 48.975 29.4634V27.7674C48.975 27.5295 49.1679 27.3366 49.4057 27.3366H51.1017C51.3396 27.3366 51.5325 27.5295 51.5325 27.7674V29.4634Z"
      fill="#BCBEC0"
    />
    <path
      d="M51.6805 23.7305H48.827C48.3513 23.7305 47.9655 24.1162 47.9655 24.5919V30.0837C47.9655 30.5594 48.3513 30.9452 48.827 30.9452H51.6805C52.1562 30.9452 52.5419 30.5594 52.5419 30.0837V24.5919C52.5419 24.1162 52.1562 23.7305 51.6805 23.7305ZM51.5323 29.4644C51.5323 29.7023 51.3395 29.8951 51.1016 29.8951H49.4056C49.1678 29.8951 48.9749 29.7023 48.9749 29.4644V27.7684C48.9749 27.5306 49.1678 27.3377 49.4056 27.3377H51.1016C51.3395 27.3377 51.5323 27.5306 51.5323 27.7684V29.4644Z"
      fill="white"
    />
    <path
      d="M51.196 25.3526H49.3115C49.1257 25.3526 48.975 25.2019 48.975 25.0161C48.975 24.8304 49.1257 24.6797 49.3115 24.6797H51.196C51.3818 24.6797 51.5325 24.8304 51.5325 25.0161C51.5325 25.2019 51.3818 25.3526 51.196 25.3526Z"
      fill="#D1D3D4"
    />
    <path
      d="M51.196 26.4424H49.3115C49.1257 26.4424 48.975 26.2918 48.975 26.106C48.975 25.9202 49.1257 25.7695 49.3115 25.7695H51.196C51.3818 25.7695 51.5325 25.9202 51.5325 26.106C51.5325 26.2918 51.3818 26.4424 51.196 26.4424Z"
      fill="#D1D3D4"
    />
    <path
      d="M73.8356 67.555L68.1471 73.3516L62.2961 67.555L65.8717 67.555L65.8717 59.5042L70.26 59.5042L70.585 67.555L73.8356 67.555Z"
      fill="#A77223"
    />
    <path
      d="M66.118 58.9245L69.4357 58.9245C70.045 58.9245 70.5415 59.4056 70.5415 59.996L70.5415 66.9608L73.8592 66.9608C74.0826 66.9608 74.2849 67.0915 74.3701 67.2918C74.4563 67.4922 74.4088 67.7215 74.2506 67.8758L68.1683 73.7691C67.9527 73.978 67.6021 73.978 67.3865 73.7691L61.3042 67.8758C61.146 67.7226 61.0985 67.4922 61.1847 67.2918C61.2688 67.0915 61.4712 66.9608 61.6945 66.9608L65.0122 66.9608L65.0122 59.996C65.0122 59.4056 65.5087 58.9245 66.118 58.9245ZM72.5244 68.0323L69.9886 68.0323C69.6834 68.0323 69.4357 67.7922 69.4357 67.4965L69.4357 59.996L66.118 59.996L66.118 67.4965C66.118 67.7922 65.8703 68.0323 65.5651 68.0323L63.0293 68.0323L67.7769 72.6322L72.5244 68.0323Z"
      fill="#A77223"
    />
    <path
      d="M34.2451 41.8694C33.4858 41.8694 32.8705 41.2541 32.8705 40.4947V37.7965C32.8705 37.0371 33.4858 36.4219 34.2451 36.4219C35.0044 36.4219 35.6197 37.0371 35.6197 37.7965V40.4947C35.6197 41.2539 35.0046 41.8694 34.2451 41.8694Z"
      fill="#404B58"
    />
    <path
      d="M66.4492 41.8694C65.6899 41.8694 65.0746 41.2541 65.0746 40.4947V37.7965C65.0746 37.0371 65.6899 36.4219 66.4492 36.4219C67.2085 36.4219 67.8238 37.0371 67.8238 37.7965V40.4947C67.8238 41.2539 67.2083 41.8694 66.4492 41.8694Z"
      fill="#404B58"
    />
    <path
      d="M50.4299 43.9437C48.3902 43.9437 46.4505 43.0602 45.1084 41.52C44.6095 40.9476 44.6692 40.0792 45.2416 39.5805C45.8142 39.0818 46.682 39.1413 47.1811 39.7137C48.0011 40.6549 49.1853 41.1944 50.4301 41.1944C51.675 41.1944 52.8592 40.6549 53.6792 39.7137C54.1777 39.1415 55.0461 39.0818 55.6186 39.5805C56.1908 40.0792 56.2506 40.9476 55.7519 41.52C54.4093 43.0601 52.4697 43.9437 50.4299 43.9437Z"
      fill="#404B58"
    />
    <path
      d="M53.843 73.7616H30.9381C29.7747 73.7616 28.8317 72.5719 28.8317 71.1046V61.5828C28.8317 60.1151 29.7747 58.9258 30.9381 58.9258H53.8433C55.0064 58.9258 55.9494 60.1155 55.9494 61.5828V71.1046C55.9494 72.5719 55.0064 73.7616 53.843 73.7616Z"
      fill="white"
    />
    <path
      d="M39.4467 69.1278H35.9927L39.7888 63.5892C39.8587 63.4875 39.8964 63.366 39.8964 63.2421V62.794C39.8964 62.4548 39.6213 62.1797 39.2821 62.1797H34.195C33.8558 62.1797 33.5807 62.4548 33.5807 62.794V63.3288C33.5807 63.668 33.8558 63.9431 34.195 63.9431H37.3349L33.5551 69.451C33.4848 69.5532 33.4475 69.6747 33.4475 69.7986V70.2764C33.4475 70.6156 33.7226 70.8907 34.0618 70.8907H39.4471C39.7863 70.8907 40.0614 70.6156 40.0614 70.2764V69.7421C40.0606 69.4029 39.7859 69.1278 39.4467 69.1278Z"
      fill="#A77223"
    />
    <path
      d="M42.6626 62.1797H42.0307C41.6915 62.1797 41.4164 62.4548 41.4164 62.794V70.276C41.4164 70.6152 41.6915 70.8903 42.0307 70.8903H42.6626C43.0018 70.8903 43.2769 70.6152 43.2769 70.276V62.794C43.2769 62.4548 43.0022 62.1797 42.6626 62.1797Z"
      fill="#A77223"
    />
    <path
      d="M50.5421 62.9297C49.978 62.4322 49.2217 62.1797 48.2933 62.1797H45.7443C45.4051 62.1797 45.13 62.4548 45.13 62.794V70.276C45.13 70.6152 45.4051 70.8903 45.7443 70.8903H46.3762C46.7154 70.8903 46.9906 70.6152 46.9906 70.276V67.843H48.2774C49.2498 67.843 50.0203 67.5989 50.5668 67.1165C51.1363 66.6148 51.4248 65.9125 51.4248 65.0294C51.4257 64.1541 51.1283 63.4473 50.5421 62.9297ZM49.2845 65.802C49.0802 65.9871 48.7468 66.0809 48.2937 66.0809H46.9914V63.9435H48.3281C48.7531 63.9485 49.0718 64.0494 49.2741 64.2433C49.473 64.4335 49.5655 64.686 49.5655 65.0373C49.5651 65.495 49.4047 65.6927 49.2845 65.802Z"
      fill="#A77223"
    />
    <defs>
      <filter
        id="filter0_ddd"
        x="5.34534"
        y="6.21094"
        width="89.9521"
        height="93.5716"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="9" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow"
          result="effect2_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow"
          result="effect3_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'CompressIcon'
}
</script>
